import React from 'react'

import Mollie from './Mollie.js'

import glitch_icon from '../images/glitch-twitch.png';
import twitter_icon from '../images/icon_twitch-twitter.png';
import instagram_icon from '../images/icon_twitch-instagram.png';
// import tiktok_icon from '../images/icon_twitch-tiktok.png';
import bluesky_icon from '../images/icon_twitch-bluesky.png';


export default class extends React.Component {

  constructor(props) {
    super(props);

    let param_app, param_ext, param_thanks, ttv_app_name = "";
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      param_app = params.get('app');
      param_ext = params.get('ext');
      param_thanks = params.get('thanks');

      if(param_app && param_ext) {
        if(param_app === "IGF") ttv_app_name = "Instagram Feed+";
        if(param_app === "TWF") ttv_app_name = "Twitter Feed+";
        // if(param_app === "TTF") ttv_app_name = "TikTok Feed+";
        if(param_app === "BSF") ttv_app_name = "Bluesky Feed+";
      }
    }

    document.title = ttv_app_name+" Premium | Polymedia.nl";
    this.state = {param_app, param_ext, param_thanks, ttv_app_name};
  }

  render() {
    const {param_app, param_ext, param_thanks, ttv_app_name} = this.state;

    let polymedia_info = <div className="full polymedia">
      <div className="wrap">
        <h1 style={{margin:"0"}}><a href="https://polymedia.nl" target="_blank" rel="noopener noreferrer">poly<span>media</span></a></h1>
        <p style={{textAlign:"center", margin:"1.4em 0 0"}}>Meent 68<br />4141AD Leerdam<br />The Netherlands</p>
        <p style={{textAlign:"center", margin:"1.4em 0 0"}}><a href="https://polymedia.nl" target="_blank" rel="noopener noreferrer">Polymedia.nl</a><br /><a href="https://twitter.com/PolymediaNL" target="_blank" rel="noopener noreferrer">twitter.com/PolymediaNL</a><br /><a href="https://www.linkedin.com/in/peterdotplus" target="_blank" rel="noopener noreferrer">linkedin.com/in/peterdotplus</a></p>
      </div>
    </div>;

    let premium_header = <div className="full header">
      <div className="wrap">
        <h1>{ttv_app_name}</h1>
        <h2>Premium</h2>
      </div>
    </div>;

    if(param_app && param_ext && param_thanks === null && ttv_app_name !== "") {
      return (
        <div>
          {premium_header}

          <div className="full" style={{paddingBottom:"2em", background:"0"}}>
            <div className="wrap">
              <div className="content-text">
                <h1 style={{textAlign:"left"}}>Unlock Premium for {ttv_app_name}</h1>
                <h2 style={{textAlign:"left", fontSize:"1.3em", opacity:".4"}}>Get more features and a unique viewing experience.</h2>
                <ul>
                  <li>option to upload your own <b>custom header image</b></li>
                  <li>option to pick colors for <b>dark mode <i>and</i> light mode</b></li>
                  {(param_app === "IGF" || param_app === "TTF") && <li>choose between <b>grid or list</b> layout</li>}
                </ul>
              </div>
            </div>
          </div>

          <div className="full" style={{paddingTop:"0", background:"0"}}>
            <div className="wrap">
              <div className="content-text" style={{maxWidth:"370px"}}>
                <div className="card">
                  <Mollie title="Premium" app={param_app} ext={param_ext} app_name={ttv_app_name} />
                </div>
              </div>
            </div>
          </div>

          {polymedia_info}
        </div>
      );
    } else if(param_app && param_ext && param_thanks === "" && ttv_app_name !== "") {
      return (
        <div>
          {premium_header}

          <div className="full" style={{paddingBottom:"2em", background:"0", minHeight:"555px"}}>
            <div className="wrap">
              <div className="content-text">
                <h1 style={{textAlign:"left"}}>Thank you!</h1>
                <p>Please re-open the Configuration Panel on Twitch and confirm that the Premium Tab now says "Premium Enabled" instead of "Go Premium".</p>
                <p>Follow <a href="https://twitter.com/PolymediaNL" target="_blank" rel="noopener noreferrer">@PolymediaNL on Twitter</a>.</p>
              </div>
            </div>
          </div>

          {polymedia_info}
        </div>
      );
    } else {
      return (
        <div>
          <div className="fullpage">
          <div className="wrap" style={{textAlign:"center", color:"#fff", paddingTop:"2em"}}>Please use the "Go Premium" button in the Configuration Panel of one of the following extensions:</div>
          <div className="wrap" id="projects" style={{maxWidth:"580px"}}>
            <div className="project">
              <div className="project-icon"><a href="https://dashboard.twitch.tv/extensions/dy9or3jkex4hkrfm6nhsww2821g8eu" target="_blank" rel="noopener noreferrer"><img src={twitter_icon} alt="Twitch Twitter Feed+" /><img className="twitch-glitch" src={glitch_icon} alt="Twitch Glitch" /></a></div>
              <div className="project-description"><h1><a href="https://dashboard.twitch.tv/extensions/dy9or3jkex4hkrfm6nhsww2821g8eu" target="_blank" rel="noopener noreferrer">Twitter Feed+</a></h1><h2>Extension for Twitch</h2></div>
            </div>

            <div className="project">
              <div className="project-icon"><a href="https://dashboard.twitch.tv/extensions/h0ije9m9fnhw3oc1sxtqiba8bspci2" target="_blank" rel="noopener noreferrer"><img src={instagram_icon} alt="Twitch Instagram Feed+" /><img className="twitch-glitch" src={glitch_icon} alt="Twitch Glitch" /></a></div>
              <div className="project-description"><h1><a href="https://dashboard.twitch.tv/extensions/h0ije9m9fnhw3oc1sxtqiba8bspci2" target="_blank" rel="noopener noreferrer">Instagram Feed+</a></h1><h2>Extension for Twitch</h2></div>
            </div>

            {/*<div className="project">
              <div className="project-icon"><a href="https://dashboard.twitch.tv/extensions/3ijr57wljo61kkmnvix1e63qmmancs" target="_blank" rel="noopener noreferrer"><img src={tiktok_icon} alt="Twitch TikTok Feed+" /><img className="twitch-glitch" src={glitch_icon} alt="Twitch Glitch" /></a></div>
              <div className="project-description"><h1><a href="https://dashboard.twitch.tv/extensions/3ijr57wljo61kkmnvix1e63qmmancs" target="_blank" rel="noopener noreferrer">TikTok Feed+</a></h1><h2>Extension for Twitch</h2></div>
            </div>*/}

            <div className="project">
              <div className="project-icon"><a href="https://dashboard.twitch.tv/extensions/4ct78hc05y5z05g2yt33f4cs5kju2d" target="_blank" rel="noopener noreferrer"><img src={bluesky_icon} alt="Twitch Bluesky Feed+" /><img className="twitch-glitch" src={glitch_icon} alt="Twitch Glitch" /></a></div>
              <div className="project-description"><h1><a href="https://dashboard.twitch.tv/extensions/4ct78hc05y5z05g2yt33f4cs5kju2d" target="_blank" rel="noopener noreferrer">Bluesky Feed+</a></h1><h2>Extension for Twitch</h2></div>
            </div>
          </div>
          </div>

          {polymedia_info}
        </div>
      );
    }

  } // render()


} // class



// WEBPACK FOOTER //
// ./src/containers/Start.js